import { connect } from "react-redux";
import { ProgressBar } from "primereact/progressbar";

import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import {
  initCreateCompaniesScreen,
  createCompanies,
  editCompanies,
  fetchCompaniesById,
} from "../../../../redux/actions/System/Companies";
import { useEffect } from "react";
import { setIsformDirty } from "../../../../redux/actions/common/form";
import CreateCompaniesComponent from "../../../../component/System/Companies/CreateCompanies";
import { useParams } from "react-router-dom";

const CreateCompaniesContainer = (props) => {
  const {
    createCompanies,
    editCompanies,
    isLoading,
    isCompaniesCreateSuccess,
    isCompaniesCreateError,
    isCompaniesDetailSuccess,
    isCompaniesDetailError,
    isCompaniesEditSuccess,
    isCompaniesEditError,
    isEdit,
    initCreateCompaniesScreen,
    formFieldValueMap,
    fetchCompaniesById,
    shouldBlockNavigation,
  } = props;

  const { id } = useParams();

  const callAPIasync = async () => {
    initCreateCompaniesScreen();
    if (isEdit) {
      await fetchCompaniesById({ id: id });
    }
  };

  useEffect(() => {
    callAPIasync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit]);

  useEffect(() => {
    if (isCompaniesCreateSuccess || isCompaniesEditSuccess) {
      shouldBlockNavigation(false);
    }
  }, [isCompaniesCreateSuccess, isCompaniesEditSuccess, shouldBlockNavigation]);

  const createCompaniesProps = {
    createCompanies,
    initCreateCompaniesScreen,
    editCompanies,
    isLoading,
    isEdit,
    isCompaniesDetailSuccess,
    isCompaniesCreateSuccess,
    isCompaniesEditSuccess,
    isCompaniesEditError,
    formFieldValueMap,
    shouldBlockNavigation,
  };

  const getToastProps = () => {
    if (isCompaniesCreateSuccess || isCompaniesEditSuccess) {
      const toastTitle = isEdit
        ? "Company Updated Successfully"
        : "Submitted Company Creation Request Successfully, Please check your email.";
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle,
        shouldShowToast: true,
      };
    }

    if (
      isCompaniesCreateError ||
      isCompaniesDetailError ||
      isCompaniesEditError
    ) {
      let toastTitle = "Error while Creating Company";
      if (isCompaniesEditError) {
        toastTitle = "Error while updating Company";
      } else if (isCompaniesDetailError) {
        toastTitle =
          "Error while performing operation. Please refresh your browser";
      }

      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  return (
    <>
      {isLoading && renderProgressBar()}
      <EzToast {...getToastProps()} />
      <CreateCompaniesComponent {...createCompaniesProps} />
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    isLoading: selectFromCompaniesReducer(state, "isLoading"),
    isCompaniesCreateSuccess: selectFromCompaniesReducer(
      state,
      "isCompaniesCreateSuccess"
    ),
    isCompaniesCreateError: selectFromCompaniesReducer(
      state,
      "isCompaniesCreateError"
    ),
    isCompaniesDetailSuccess: selectFromCompaniesReducer(
      state,
      "isCompaniesDetailSuccess"
    ),
    isCompaniesDetailError: selectFromCompaniesReducer(
      state,
      "isCompaniesDetailError"
    ),
    isCompaniesEditSuccess: selectFromCompaniesReducer(
      state,
      "isCompaniesEditSuccess"
    ),
    isCompaniesEditError: selectFromCompaniesReducer(
      state,
      "isCompaniesEditError"
    ),
    formFieldValueMap: selectFromCompaniesReducer(state, "formFieldValueMap"),
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initCreateCompaniesScreen: () => dispatch(initCreateCompaniesScreen()),
    createCompanies: (payload) => dispatch(createCompanies(payload)),
    editCompanies: (payload) => dispatch(editCompanies(payload)),
    shouldBlockNavigation: (isFormDirty) => dispatch(setIsformDirty(isFormDirty)),
    fetchCompaniesById: (payload) => dispatch(fetchCompaniesById(payload)),
  };
};

const selectFromCompaniesReducer = (state, path) => {
  return selectCompaniesReducer(state)[path];
};

const selectCompaniesReducer = ({ companiesReducer }) => {
  return companiesReducer;
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCompaniesContainer);
